import React, { useMemo, useState, useContext } from 'react'

import { ThemeProvider as StyledProvider } from 'styled-components'
import { ToastContainer } from 'react-toastify'
import { merge } from 'lodash'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'

import { ChakraProvider, CSSReset } from '@chakra-ui/react'

import ThemeContext from './context'
import { cssKey } from './config'
import GlobalStyles from '../styles/global'
import profileColors, { VariantsProps } from '../styles/colors'
import { theme as HubTheme, Theme } from '../styles'

interface ThemeProps {
  cssVarPrefix?: string
  theme?: Partial<Theme>
}

const ThemeContainer: React.FC<ThemeProps> = ({
  children,
  theme,
  cssVarPrefix
}) => {
  const [prof, setProfile] = useState<VariantsProps>('default')
  const context = useContext(ThemeContext)

  context.theme = ({ profile }) => setProfile(profile)

  const renderTheme = useMemo(() => {
    const profileTheme = profileColors({
      profile: prof
    }).blue

    const defaultTheme = HubTheme(cssVarPrefix)

    const hubThemeProfile = {
      ...defaultTheme,
      colors: {
        ...defaultTheme.colors,
        blue: profileTheme
      }
    }

    return merge(hubThemeProfile, theme)
  }, [cssVarPrefix, prof, theme])

  return (
    <CacheProvider value={createCache({ key: cssKey })}>
      <ChakraProvider theme={renderTheme} resetCSS>
        <StyledProvider theme={renderTheme as any}>
          <CSSReset />
          <GlobalStyles />
          {children}
          <ToastContainer
            position="bottom-center"
            autoClose={4000}
            hideProgressBar={false}
            newestOnTop={false}
            closeButton={false}
            limit={1}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </StyledProvider>
      </ChakraProvider>
    </CacheProvider>
  )
}

export default ThemeContainer
